import { styled } from '@mui/system';

export const StyledHeader = styled('header')`
    background-color: #fff;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    box-shadow:0 2px 5px rgba(0, 0, 0, .1);
`

export const HeaderSvg = styled('svg')`

`

export const Logo = styled('a')`
    text-decoration: none;
    color: #666;
    display: flex;
    align-items: center;
    
    img {
        width: 180px;
    }

    span {
        font-size: 12px;
        margin-left: 8px;
    }

    @media (max-width: 991px) {
        img {
            width: 120px;
        }
    }
`

export const PageWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    height: 100%;

    h2 {
        font-size: 2.2rem;
        line-height: 1.2;
        margin-top: 0;
        margin-bottom: 40px;
    }

    @media (max-width: 991px) {
        h2 {
            font-size: 1.8rem !important;
            text-align: center;
            margin-bottom: 32px;
        }
    }
`

export const PageMain = styled('div')`
    flex: 1;
`

export const ChartWrapper = styled('div')<{ isTwoCompetitors?: boolean }>`
    height: 400px;
    width: 100%;
    margin: 24px 0 0 0;
    max-width: ${({ isTwoCompetitors }) => isTwoCompetitors ? '600px' : '100%'};
    margin-left: ${({ isTwoCompetitors }) => isTwoCompetitors ? 'auto' : '0'};
    margin-right: ${({ isTwoCompetitors }) => isTwoCompetitors ? 'auto' : '0'};

    @media (max-width: 991px) {
        height: 320px;
    }

    @media (max-width: 768px) {
        height: 260px;
        margin-left: ${({ isTwoCompetitors }) => isTwoCompetitors ? 'auto' : '-15px'};
        max-width: ${({ isTwoCompetitors }) => isTwoCompetitors ? '500px' : '100%'};
    }
`

export const StyledFooter = styled('div')`
    background-color: #7e8083;
    color: #FFF;
    font-size: 13px;
    padding: 18px 4vw 0;

    a {
        color: #fff;
        font-size: 13px;
    }

    a:hover {
        text-decoration: underline;
    }

    p {
        font-size: 11px;
        color: #fff;
        margin-bottom: 1.5em;
    }

    @media (max-width: 768px) {
        
    }
`

export const FooterNav = styled('div')`
    border-bottom: 1px solid #fff;
    padding-bottom: 12px;
    margin-bottom: 12px;
`

export const FooterSocialLinks = styled('div')`
    display: flex;
    align-items: center;

    a {
        padding: 0.75em;
        border: 2px solid #2372B9;
        border-radius: 1000px;
        color: #fff;
        transition: background-color 0.25s ease-in-out 0s;
        display: inline-flex;
        width: 52px;
        height: 52px;
        align-items: center;
        justify-content: center;
        margin-left: .75rem;
        box-sizing: border-box;
    }

    a:first-child {
        margin-left: 0;
    }

    a:hover, a:focus {
        background-color: #2372B9;
    }

    svg {
        height: 1.5em;
        width: 1.5em;
        margin: auto;
    }

    @media (max-width: 768px) {
        margin-bottom: 32px;
    }
`

export const ChartTooltips = styled('div')`
    background: #fff;
    border: 1px solid #2372B980;
    border-radius: 8px;
    padding: 12px 16px;
    text-align: left;

    h6 {
        font-size: 12px;
        font-weight: 700;
        color: #3a3a3a;
        margin: 0 0 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f2f2f2;
    }

    p {
        margin: 0;
    }
`

export const ViewMoreBtnRow = styled('div')<{ isTwoCompetitors?: boolean }>`
    display: flex;
    justify-content: center;
    padding-left: ${({ isTwoCompetitors }) => isTwoCompetitors ? '1%' : '2%'};
    gap: ${({ isTwoCompetitors }) => isTwoCompetitors ? '100px' : '0'};

    & > div {
        flex: 1;
        text-align: center;
        max-width: ${({ isTwoCompetitors }) => isTwoCompetitors ? '200px' : 'none'};
    }

    .buttons-section {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .text-button {
        padding:15px 0; 
        text-decoration: underline;
    }

    .constellation-button {
        background: #fff;
        border-radius: 11px;
        padding: 10px 0;
    }

    .constellation-button img {
        max-width: 125px;
    }
    img {
        max-width: 80px;
        height: auto;
        object-fit: contain;
    }
    @media (max-width: 1042px) {
        // .text-button{
        //     white-space: nowrap;
        //     justify-content: start;
        //     width: 210px;
        //     overflow: hidden;   
        //     display: -webkit-box;
        //     -webkit-box-orient: vertical;
        //     line-height: 1.2;
        //     -webkit-line-clamp: 1;
        //     text-align: center;
        //     height: 3.9em;
        //     max-height: 4em;
        // }
        .css-1ivffp-MuiGrid-root{
            flex-basis: 100%;
            max-width: 100%;
        }
    }
    @media (max-width: 991px) {
        // .text-button{
        //     white-space: nowrap;
        //     justify-content: start;
        //     width: 150px;
        //     overflow: hidden;   
        //     display: -webkit-box;
        //     -webkit-box-orient: vertical;
        //     line-height: 1.2;
        //     -webkit-line-clamp: 1;
        //     text-align: center;
        //     height: 3.9em;
        //     max-height: 4em;
        // }
        
    }
    @media (max-width: 768px) {
        padding-left: 2%;

        .constellation-button img {
            max-width: 80px;
        }
        button {
            font-size: 11px;
            padding: 2px 6px;
        }
        .signup-button {
            display: none;
        }
        // .text-button{
        //     white-space: normal;
        //     justify-content: center;
        //     width: 100px;
        //     overflow: hidden;
        //     display: -webkit-box;
        //     -webkit-line-clamp: 2;
        //     -webkit-box-orient: vertical;
        //     line-height: 1.2;
        //     text-align: center;
        //     height: 3.9em;
        //     max-height: 4em;
        // }
        
    }
    
`

export const HeaderMenu = styled('div')`
    display: flex;
    align-items: center;

    @media (max-width: 991px) {
        display: ${({ active }: { active: string }) => (active && active === 'true') ? 'flex' : 'none'};
        position: fixed;
        top: 52px;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #fff;
        z-index: 999;
        flex-direction: column;
        align-items: flex-start;
        padding: 1.375rem 0px 0.625rem 3.5rem;
        
        button {
            margin-bottom: 1.375rem;
            font-size: 1.25rem;
            padding: 0.75rem 2.125rem;
        }
    }
`

export const HeaderMenuItem = styled('a')`
    color: #2372b9;
    font-weight: 500;
    text-decoration: none;
    font-size: 15px;
    // text-transform: uppercase;
    border: 1px solid #2372B980;
    border-radius: 8px;
    font-weight: 600;
    padding: 8px 15px;

    :hover {
        color: #f47b27;
        border: 1px solid #f47b2780;
    }

    @media (max-width: 991px) {
        font-size: 1.25rem;

        &:last-of-type {
            margin-bottom: 2.75rem;
        }
    }
`

export const StyledHeaderInner = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4em;
    z-index:1;
    button {
        box-shadow: none;
        margin-right: 1rem;

        :last-child {
            margin-right: 0;
        }
    }

    img {
        margin-right:30px;

        :last-child {
            margin-right: 0;
        }
    }

    @media (max-width: 991px) {
        height: 52px;
    }
`

interface EntrySectionProps {
    isCompare?: boolean;
}


export const EntrySection = styled('div')<EntrySectionProps>`
    /* margin-bottom: 64px; */
    padding-top: 10px;
    background: #fff;  
      .MuiGrid-root {
        background:none;
    }
    .css-1xxbdzk-MuiFormLabel-root-MuiInputLabel-root {
        color: #000;
    }
    .MuiGrid-container{
        padding:0;
    }
    .MuiTextField-root {
        border-radius: 5px;
    }

    @media (max-width: 1100px) {
       padding:${({isCompare}) => isCompare ? '20px 0 20px 0' : '40px 0'} ;
    }

    @media (max-width: 768px) {
        background: ${({ isCompare }) =>
        isCompare
          ? 'linear-gradient(#2372B9 0%, #378FDE 115.83%)'
          : 'none'};  
        .background-div{
            background:none;
        }

        padding: 10px;
    }

    @media (min-width : 1440px) {
        .background-div{
          background-size:contain;
         }
    }
`

export const MenuToggle = styled('button')`
    cursor: pointer;
    border: 0 none;
    mask-image: ${({ active }: { active: string }) => (active && active === 'true') ? 'url("/images/X.svg")' : 'url("/images/Menu.svg")'};
    mask-position: 0 0;
    mask-repeat: no-repeat;
    background-color: #888;
    width: 24px;
    height: 24px;
    mask-size: cover;
    display: none;
    margin-right: 0 !important;

    @media (max-width: 991px) {
        display: inline-block;
    }
`

export const ModalBodyStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        md: 650,
        xs: '85%'
    },
    bgcolor: '#fff',
    boxShadow: 24,
    borderRadius: 4,
    p: 2,
};

export const ChartFooter = styled('div')`
    margin: 24px 12px;
    color: #999;
    font-size: 13px;
    text-align: center;
`

export const ModalCloseBtn = styled('button')`
    display: inline-block;
    width: 32px;
    height: 32px;
    mask: url('/images/X.svg') 0 0 no-repeat;
    background-color: ${({ theme }) => theme.palette.primary.main};
    border: 0 none;
    cursor: pointer;
`

export const SavingRow = styled('div')`
    margin: 4px 0;

    span {
        color: #2372B9;
        font-size: 32px;
        font-weight: 700;
        margin-left: 12px;
    }

    @media (max-width: 768px) {
        text-align: left;

        span {
            font-size: 24px;
            margin-left: 0;
        }
    }
`